(function(){
     class SecondaryNavigation extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.toggle = this.querySelector('[data-secondary-navigation-toggle]');
            this.secondaryNavigationWrapper = document.querySelectorAll('[data-secondary-navigation-wrapper]');
            this.secondaryNavigationDrawer = document.querySelectorAll('[data-secondary-navigation-drawer]');
            this.mobileBreakpoint = 750;

            if(this.toggle && this.secondaryNavigationWrapper && this.secondaryNavigationWrapper.length) {
                this.toggle.addEventListener('click', this.toggleMenu.bind(this));

                this.toggleTop = this.toggle.querySelector('.burger-menu--line-top');
                this.toggleMiddle = this.toggle.querySelector('.burger-menu--line-middle');
                this.toggleBottom = this.toggle.querySelector('.burger-menu--line-bottom');
            }
        }

        toggleAnimationOpen(tl) {
          tl.to(this.toggleTop, { duration: 0.8, rotation: 45, y: (this.toggle?.clientHeight / 2), ease: "elastic.out(1,0.6)" }, 0);
          tl.to(this.toggleMiddle, { duration: 0.8, opacity: 0, ease: "elastic.out(1,0.6)" }, 0);
          tl.to(this.toggleBottom, { duration: 0.8, rotation: -45, y: ((this.toggle?.clientHeight / 2 ) * -1), ease: "elastic.out(1,0.6)" }, 0);
        }

        toggleAnimationClose(tl) {
          tl.to(this.toggleTop, { duration: 0.8, rotation: 0, y: 0, ease: "elastic.out(1,0.6)" }, 0);
          tl.to(this.toggleMiddle, { duration: 0.8, opacity: 1, y: 0, ease: "elastic.out(1,0.6)" }, 0);
          tl.to(this.toggleBottom, { duration: 0.8, rotation: 0, y: 0, ease: "elastic.out(1,0.6)" }, 0);
        }

        toggleMenu() {
            if(window.innerWidth < this.mobileBreakpoint) {
              this.secondaryNavigationDrawer?.forEach((wrapper) => {
                const dataSelector = 'data-secondary-navigation-drawer';
                const menuStatus = wrapper?.getAttribute(dataSelector);
                const header = document.querySelector('.header-section');
                let headerBottom, drawerHeight;

                if(header) {
                  headerBottom = header.getBoundingClientRect().bottom;
                  drawerHeight = window.innerHeight - headerBottom;
                }

                  if(menuStatus === 'open') {
                      let tl = window.gsap.timeline({
                          onComplete: function() {
                              wrapper.setAttribute(dataSelector, '');
                              document.documentElement.removeAttribute('scroll-lock');
                          }.bind(this)
                      });


                      this.toggleAnimationClose(tl);
                      tl.to(wrapper, {
                          duration: 0.8,
                          ease: "elastic.out(1,0.6)",
                          height: 0,
                      }, 0);
                  } else {
                    document.documentElement.setAttribute('scroll-lock', '');
                      let tl = window.gsap.timeline({
                          onComplete: function() {
                              wrapper.setAttribute(dataSelector, 'open');
                          }.bind(this)
                      });

                      this.toggleAnimationOpen(tl);

                      window.gsap.to(wrapper, {
                          duration: 0.8,
                          ease: "elastic.out(1,0.6)",
                          height: drawerHeight,
                      });
                  }
              });
            } else {
              this.secondaryNavigationWrapper?.forEach((wrapper) => {
                const dataSelector = 'data-secondary-navigation-wrapper';
                const menuStatus = wrapper?.getAttribute(dataSelector);

                  if(menuStatus === 'open') {
                      let tl = window.gsap.timeline({
                          onComplete: function() {
                              wrapper.setAttribute(dataSelector, '');
                          }.bind(this)
                      });


                      this.toggleAnimationClose(tl);
                      tl.to(wrapper, {
                          duration: 0.8,
                          ease: "elastic.out(1,0.6)",
                          height: 0,
                      }, 0);
                  } else {
                      let tl = window.gsap.timeline({
                          onComplete: function() {
                              wrapper.setAttribute(dataSelector, 'open');
                          }.bind(this)
                      });

                      this.toggleAnimationOpen(tl);
                      window.gsap.to(wrapper, {
                          duration: 0.8,
                          ease: "elastic.out(1,0.6)",
                          height: "auto",
                      });
                  }
              });
            }
        }
    }

    customElements.define('secondary-navigation', SecondaryNavigation);
})();
